import { NavItem } from '../../../../_metronic/helpers/utils/types';
import { homeData } from './home';
import { aboutData } from './about';
import { programsData } from './programs';
import { resourceData } from './resource';
import { contactData } from './contact';
import { successStoriesData } from './successStories';
import { walkTogetherTourData } from './walkTogetherTour';
import { corporateData } from './corporate';
import { getInvolvedData } from './getInvolved';
import { grantsData } from './grants';
import { loansData } from './loans';
import { financialLiteracyData } from './financialLiteracy';
import { mentorshipData } from './mentorship';
import { digitizationData } from './digitization';

export const navData: Record<string, NavItem[]> = {
  homeData,
  aboutData,
  programsData,
  resourceData,
  contactData,
  walkTogetherTourData,
  successStoriesData,
  corporateData,
  getInvolvedData,
  grantsData,
  loansData,
  financialLiteracyData,
  mentorshipData,
  digitizationData
};
